import { render } from "./Abt1c.vue?vue&type=template&id=1f1c053e"
import script from "./Abt1c.vue?vue&type=script&lang=js"
export * from "./Abt1c.vue?vue&type=script&lang=js"

import "./Abt1c.vue?vue&type=style&index=0&id=1f1c053e&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__